import { render, staticRenderFns } from "./about-footer-menu.vue?vue&type=template&id=16b78461&scoped=true"
var script = {}
import style0 from "./about-footer-menu.vue?vue&type=style&index=0&id=16b78461&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b78461",
  null
  
)

export default component.exports